import { SpaceProps, space, ColorProps, color, BackgroundProps, background, LayoutProps, layout } from 'styled-system';
import styled from 'styled-components';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';
import { Box } from '@bpba/ui-components';

type Props = SpaceProps & ColorProps & BackgroundProps & LayoutProps;

const StyledCloseIcon = styled(CloseIcon)<Props>(space, color, background, layout, {
  opacity: 1,
  ':hover': {
    opacity: 0.5,
  },
});

StyledCloseIcon.defaultProps = {
  width: '1em',
};

export const CloseIconContainer = (props: React.ComponentProps<typeof StyledCloseIcon>) => {
  return (
    <Box marginRight="4px" justifyContent="center">
      <StyledCloseIcon {...props} />
    </Box>
  );
};
